import * as React from 'react';
import BasePanel from 'components/generic/Panel';
import PanelHeaderTitle from 'components/generic/PanelHeaderTitle';
import ContentUnpad from 'components/generic/ContentUnpad';

export default function Panel({title, initialOpen = true, children}) {
	const [, setIsOpen] = React.useState(initialOpen);
	return (
		<BasePanel
			headerTitle={<PanelHeaderTitle className="select-none">{title}</PanelHeaderTitle>}
			toggleable
			toggleFunc={setIsOpen}
			initialToggled={initialOpen}
		>
			<ContentUnpad>{children}</ContentUnpad>
		</BasePanel>
	);
}
